import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './SellAllSharesClosedToNewInvestors.scss';

import Button from '../../Shared/Button/Button';
import { updateExchangeFund } from '../../../redux/modules/exchangeTransaction/exchangeTransaction.module';
import { ExchangeTransactionActionType } from '../../../redux/modules/exchangeTransaction';

import { SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS } from '../../../redux/modules/modals/modals.module';
import { updateSellFund } from '../../../redux/modules/sellTransaction/sellTransaction.module';
import { updateConversionFund } from '../../../redux/modules/rothConversionTransaction/rothConversionTransaction.module';
import { UNIT } from '../../../settings/settings';

import {
  isAppSell,
  isCollegeDistribute,
  isCollegeExchange,
  isExchange,
  isSell,
  isRothConversion,
} from '../../../utils/transactions-util';

class SellAllSharesClosedToNewInvestors extends Component {
  constructor(props) {
    super(props);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick(clicked) {
    const {
      closeModal,
      fund: { agreementID, grossUnit, balanceAsOf },
      actions: { updateSellFund, updateExchangeFund, updateConversionFund },
    } = this.props;

    (isExchange() || isCollegeExchange()) &&
      updateExchangeFund(
        ExchangeTransactionActionType.UPDATE_EXCHANGE_FROM_FUND,
        {
          agreementID,
          closeout: clicked,
          inFocus: !clicked,
          grossAmount: undefined,
          grossUnit: clicked ? UNIT.ALL_SHARES : UNIT.DOLLARS,
        }
      );

    (isSell() || isCollegeDistribute() || isAppSell()) &&
      updateSellFund({
        agreementID,
        closeout: clicked,
        inFocus: !clicked,
        grossAmount: clicked ? 100 : 0,
        grossUnit: clicked ? UNIT.PERCENT : grossUnit,
      });

    // if roth conversion
    if (isRothConversion()) {
      updateConversionFund(
        agreementID,
        {
          closeout: clicked,
          inFocus: !clicked,
          grossAmount: 100,
          grossAmountDollars: clicked ? balanceAsOf : 0,
          grossUnit: clicked ? UNIT.PERCENT : UNIT.DOLLARS,
        },
        1
      );
    }

    closeModal(SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS);
  }

  render() {
    const {
      fund: { agreementID },
    } = this.props;
    return (
      <div className="e2e-sell-all-shares-closed-to-new-investors-container">
        <div className="sell-all-shares-closed-to-new-investors-heading">
          Closed to New Investors
        </div>

        <div className="sell-all-shares-closed-to-new-investors-disclosure">
          This fund is closed to new investors except for T. Rowe Price clients
          with a minimum Summit Program balance of $250,000 or clients who open
          a new IRA account in the fund through a direct rollover from an
          employer-sponsored retirement plan. If you close this fund, you'll be
          unable to purchase back in unless you meet one of these requirements.
        </div>

        <div className="sell-all-shares-closed-to-new-investors-button-container">
          <a
            className="trp-pdf-link e2e-sell-all-shares-closed-to-new-investors-cancel-button sell-all-shares-closed-to-new-investors-cancel-button"
            id="e2e-sell-all-shares-closed-to-new-investors-modal-cancel"
            onClick={() => {
              this.handleButtonClick(false);
            }}
          >
            Clear Transaction
          </a>

          <Button
            buttonType="primary"
            className="btn-trp-primary e2e-sell-all-shares-closed-to-new-investors-confirm-button sell-all-shares-closed-to-new-investors-confirm-button"
            id={`sell-all-shares-closed-to-new-investors-modal-ok-btn-${agreementID}`}
            onClick={() => {
              this.handleButtonClick(true);
            }}
            styleName="sell-all-shares-closed-to-new-investors-ok-button"
          >
            OK
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        updateSellFund,
        updateExchangeFund,
        updateConversionFund,
      },
      dispatch
    ),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellAllSharesClosedToNewInvestors
);
